/** Web / non-native: push registration is a no-op. Native uses `firebase.messaging.native.ts`. */
export const firebaseMessaging = {
	async initialize(): Promise<void> {},
	destroy(): void {},
	async syncTokenToBackend(): Promise<void> {},
};
